module.exports = __webpack_public_path__ + "img/ic_fluent_info_20_regular.30cc7eba.svg";